import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import ImageDisplay from '../imageDisplay';

export const StillHaveQuestions = ({
	headline,
	description,
	cta,
	image,
	sectionClassName = '',
	contentClassName = '',
}) => {
	return (
		<div className={`section have-questions ${sectionClassName}`}>
			<div
				className={`section__content have-questions__content ${contentClassName}`}
			>
				<figure className="have-questions__image">
					<ImageDisplay
						className="have-questions__image-svg"
						alt={image?.description}
						image={image?.gatsbyImageData}
						src={image?.file?.url}
					/>
				</figure>
				<div className="have-questions__body">
					<h1 className="typography typography--h2 typography--white">
						{headline}
					</h1>
					<p className="typography typography--body-big typography--white">
						{description?.description}
					</p>
					{cta?.title && (
						<Link to={cta.link} className="have-questions__body-button btn">
							{cta.title}
						</Link>
					)}
				</div>
			</div>
		</div>
	);
};

StillHaveQuestions.propTypes = {
	image: PropTypes.shape({
		gatsbyImageData: PropTypes.object,
		file: PropTypes.object,
		description: PropTypes.string,
	}),
	headline: PropTypes.string.isRequired,
	description: PropTypes.object.isRequired,
	sectionClassName: PropTypes.string,
	contentClassName: PropTypes.string,
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}),
};

StillHaveQuestions.defaultProps = {
	image: null,
	cta: null,
};

export default StillHaveQuestions;
